/**
 * Classe base para todos os fields.
 * @author: Adalto Junior
 * Date: 20/09/13
 * Time: 11:47
 */


Monet.UI = Monet.UI || {};
Monet.UI.Fields = Monet.UI.Fields || {};

Monet.UI.Fields.Decimal = (function () {

    function Decimal() {

        Monet.UI.Fields.TextField.apply (this, arguments);

        this.getValue = function () {

            var value = this.input.value;

            if (value) {
                return new Monet.Format.DECIMAL(this.input.value).parseFloat().getValue();
            }

            return value;

        };

        this.setValue = function (value) {
            this.value = (value || value === 0 ? value : this.value);
            this.setValueView ();

        };

        this.setValueView = function (){

            var value = this.value;
            if (this.input && (value || value === 0)) {
                var formatter = new Monet.Format.DECIMAL(value);

                if ( this.meta && this.meta.precision ) {
                    formatter.setPrecision(this.meta.precision.substr(1));
                }

                this.input.value = formatter.format().getValue();
            }
        };

        this.createElement = function () {

            this.input = this.input || document.createElement('input');

            this.input.type = 'text';
            this.input.className = 'decimalFieldOld';

            this.input.maxLength = 20;

            if(this.maxSize){
                this.input.maxLength = this.maxSize;
            }


            this.rootEl.appendChild(this.input);

        };

        this.addEventListeners = function () {

            var precision;
            if ( this.meta && this.meta.precision ) {
                precision = this.meta.precision.substr(1);
                this.input.setAttribute('precision', precision);
            }

            $(this.input).on("keyup blur focus",function (e) {

                e.preventDefault();
                var expre = /[^0-9,.]/g;
                if ($(this).val().match(expre)) {
                    $(this).val($(this).val().replace(expre, ''));
                }

            }).maskMoney({
                prefix: '',
                decimal: Monet.I18n.locale.decimalSymbol,
                thousands: Monet.I18n.locale.digitalGrouping,
                allowNegative: true,
                allowZero: true,
                precision: parseInt(precision) || 2
            });

        };

        this.render = function () {

            this.createElement();
            this.addEventListeners();
            this.setValue (this.value);

            return this.rootEl;

        };

    }

    return Decimal;

}());